var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8SudanCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M24,4C15.296,4,7.911,9.571,5.162,17.333h37.675C40.089,9.571,32.704,4,24,4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M42.838,30.667C43.577,28.579,44,26.341,44,24c0-2.341-0.423-4.579-1.162-6.667H5.162 C4.423,19.421,4,21.659,4,24c0,2.341,0.423,4.579,1.162,6.667H42.838z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M23.999,44h0.002c8.704,0,16.088-5.571,18.836-13.333H5.162C7.911,38.429,15.295,43.999,23.999,44z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#388e3c",
    d: "M4,24c0,5.587,2.296,10.634,5.99,14.262L26.4,24L9.99,9.738C6.296,13.366,4,18.413,4,24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8SudanCircular);
export default __webpack_public_path__ + "static/media/icons8-sudan-circular.c145a48e12a310d35a170370a092635d.svg";
export { ForwardRef as ReactComponent };